module.exports = __webpack_public_path__ + "static/img/looking-forward-low.58b9487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/looking-forward-low.jpg
// module id = A9el
// module chunks = 0